<template>
<div>
  <div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <SideBar />
    <!-- /#sidebar-wrapper -->
    <!-- Cart Drawer -->
    <CartDrawer 
      :openCart="openCart" 
      :openCloseCart="openCloseCart" 
      :cartItemList="dataCart" 
      :vendorOptions="dataVendor" 
      :bulkRemoveFromCart="bulkRemoveFromCart"
      :removeFromCart="removeFromCart" 
      :createBatch="createBatch" 
      :showErrorUnit="showErrorUnit"
      :errorUnitList="errorUnitList" />
    <!-- end of cart drawer -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-muted mb-0 hover-cursor">&nbsp;Insurance /&nbsp;</p>
            <p class="text-primary mb-0 hover-cursor">Pending Declare</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
                <!-- Filter Part -->
                <div id="filterPart" class="card" >
                  <div class="row">
                    <div class="container" style="display : flex;">
                      <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">Order ID</span>
                        <input type="text" class="form-control" name="search_order_id" v-model="searchOrderCode" placeholder="Order Id">
                      </div>
                      <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">Lessee Name</span>
                        <input type="text" class="form-control" name="search_lessee_name" v-model="searchLesseeName" placeholder="Lessee Name">
                      </div>
                      <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">Product Code</span>
                        <input type="text" class="form-control" name="search_product_code" v-model="searchProductCode" placeholder="Product Code">
                      </div>
                      <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">Status</span>
                        <multiselect v-model="searchInsuranceStatus" :options="insuranceStatusOptions" label="statusName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="statusName" :multiple="false" :close-on-select="true" default></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="container-fluid" style="display : flex;">
                      <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">Start Rent (from)</span>
                        <!-- <input type="text" class="form-control" name="search_invoice_id" v-model="searchInvoiceNo" placeholder="Invoice Number"> -->
                        <input type="date" class="form-control" name="search_start_rent_from" v-model="searchStartRentFrom">
                      </div>
                     <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">Start Rent (to)</span>
                        <input type="date" class="form-control" name="search_start_rent_to" v-model="searchStartRentTo">
                      </div>
                      <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">End Rent (from)</span>
                        <input type="date" class="form-control" name="search_end_rent_to" v-model="searchEndRentFrom">
                      </div>
                      <div class="col" style="padding-left : 0px">
                        <span class="filter-field-name">End Rent (to)</span>
                        <input type="date" class="form-control" name="search_end_rent_to" v-model="searchEndRentTo">
                      </div>
                      
                    </div>
                  </div>
                  <div class="row mt-3" >
                    <div class="container-fluid">
                      <div class="col" style="display : flex; justify-content: flex-end;">
                        <div class="mr-3" style="width: 100px;">
                          <button type="submit" style="width: 100%;" class="btn btn-primary mr-2" @click="searchData">
                            Search
                          </button>
                        </div>
                        <div style="width: 100px;">
                          <button type="button" style="width: 100%;" class="btn btn-outline-secondary" @click="resetFilter">
                            Reset
                          </button>
                        </div>
                      </div>   
                    </div>
                  </div>
                </div>
                <!-- ENF OF FILTER PART -->
              <div class="row mt-3 mb-1" v-if="selectedRows.length > 0">
                <div class="col-12" >
                  <span class="filter-field-name">
                    {{ selectedRows.length }} unit(s) selected
                  </span>
                </div>
              </div>
              <div :class="selectedRows.length > 0 ? 'row' : 'row mt-3 mb-1'">
                  <div class="col-12" :style="`display : flex; justify-content:${selectedRows.length > 0 ?'space-between' : 'flex-end'};`">
                    <button 
                      v-if="selectedRows.length > 0"
                      class="btn btn-sm btn-success" 
                      style="float : right;" 
                      @click="bulkAddToCart()"
                      data-toggle="tooltip" 
                      data-placement="bottom" 
                      title="Add Selected to Unit Cart"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                        <path d="M0.0450271 2.83383C0.106334 2.66926 0.325748 2.45953 0.487081 2.4079C0.551615 2.38532 0.983989 2.37241 1.56156 2.36918C2.61668 2.36596 2.77802 2.38532 3.05874 2.54988C3.38463 2.74025 3.57501 3.01775 3.68794 3.46625L3.76538 3.76956L8.8732 3.78569L9.36658 3.78992C10.1741 4.0218 10.1741 5.12375 9.36658 5.3345L8.93773 5.3345C6.29186 5.3345 4.12677 5.34418 4.12677 5.35708C4.12999 5.37322 4.43007 6.6897 4.79791 8.2869L5.46906 11.1909L9.00549 11.2006C12.5355 11.207 12.5387 11.207 12.6258 11.1393C12.6774 11.1006 12.7291 11.0102 12.7581 10.907C12.7796 10.83 12.9044 10.6053 13.0465 10.1714C13.1731 9.78491 13.4822 9.42958 13.8818 9.50532C14.0575 9.53864 14.219 9.6056 14.3748 9.69819C14.7104 9.8976 14.8256 10.3204 14.7155 10.6949C14.5168 11.3711 14.348 11.678 14.3254 11.7355C14.1802 12.1194 13.9202 12.3848 13.5589 12.5751C13.0813 12.8236 13.1905 12.7365 9.07648 12.7494L5.39162 12.7591L5.22706 13.2011C5.13672 13.4431 5.0625 13.6884 5.0625 13.7432C5.0625 13.8787 5.16898 14.0046 5.31418 14.0465C5.39162 14.0659 6.63712 14.0788 8.94419 14.0788C12.7872 14.0788 12.5774 14.0691 12.7839 14.2659C12.9485 14.4208 13.013 14.5854 13.0162 14.8403C13.0162 15.0371 13.0033 15.0887 12.9194 15.2275C12.8581 15.3243 12.7613 15.4211 12.6645 15.4824L12.5064 15.5792L8.86352 15.5889C4.84954 15.5985 4.97861 15.6018 4.55269 15.3953C4.40426 15.3243 4.25906 15.2146 4.08805 15.0436C3.79119 14.7532 3.63631 14.4595 3.55565 14.0465C3.47175 13.6238 3.51693 13.3657 3.81701 12.5751L4.06223 11.9266L3.14263 7.93197C2.63604 5.73138 2.22303 3.92444 2.22303 3.90831C2.22303 3.8954 1.82615 3.88249 1.34215 3.87604L0.458041 3.86636L0.325748 3.77601C0.112787 3.63727 0.0159871 3.46303 0.00308039 3.19844C-0.00659962 3.04033 0.00630706 2.93385 0.0450271 2.83383Z" fill="white"/>
                        <path d="M7.09904 6.66717C6.93771 6.72848 6.74088 6.90917 6.67312 7.0576C6.61827 7.17699 6.61182 7.28669 6.61182 8.26438C6.61182 9.43243 6.61827 9.4776 6.79896 9.66798C6.94416 9.82286 7.1184 9.89384 7.35395 9.89707C7.5895 9.9003 7.75083 9.83576 7.90571 9.68088C8.11545 9.47115 8.11222 9.49696 8.11222 8.2676V7.15117L8.01542 6.99307C7.87667 6.77365 7.67662 6.65427 7.41203 6.63813C7.29587 6.63168 7.16358 6.64459 7.09904 6.66717Z" fill="white"/>
                        <path d="M9.78119 6.66735C9.62631 6.72865 9.43271 6.89967 9.34882 7.05455C9.28106 7.18684 9.27783 7.21588 9.27783 8.23874C9.27783 9.3842 9.28429 9.44551 9.46498 9.64556C9.74893 9.97146 10.2232 9.99727 10.5491 9.70364C10.8073 9.47132 10.817 9.42938 10.804 8.20002L10.7944 7.15135L10.6976 6.99324C10.5588 6.77383 10.3588 6.65444 10.0942 6.63831C9.97802 6.63185 9.84573 6.64476 9.78119 6.66735Z" fill="white"/>
                        <path d="M11.1196 5.53482C10.8771 4.27619 11.0655 3.10489 11.7977 2.05569C12.4818 1.07556 13.4198 0.452022 14.6022 0.243278C15.9656 0.00255992 17.1988 0.316117 18.2696 1.20526C19.1041 1.89805 19.6289 2.78617 19.7843 3.86069C20.0438 5.65531 19.3108 7.42904 17.5886 8.4024C17.0812 8.68913 16.5426 8.88232 15.9649 8.94727C14.8635 9.07108 13.8393 8.85638 12.9203 8.21217C11.9805 7.55336 11.3699 6.67176 11.1196 5.53482ZM18.359 6.53019C18.9349 5.6508 19.1039 4.69173 18.8396 3.68086C18.3946 1.97924 16.7734 0.811991 14.8917 1.08917C13.818 1.24733 12.9739 1.78865 12.3936 2.72369C11.9387 3.45644 11.8144 4.2568 11.922 5.09538C11.986 5.59419 12.1653 6.06159 12.4464 6.48358C12.9016 7.16706 13.5001 7.66834 14.2922 7.91347C14.8627 8.09004 15.4461 8.1149 16.0318 8.01143C17.0021 7.84002 17.7818 7.35916 18.359 6.53019Z" fill="white"/>
                        <path d="M15.8639 5.44265C15.864 5.76158 15.8648 6.06951 15.8639 6.37744C15.8632 6.62442 15.7127 6.77442 15.466 6.77677C15.2443 6.77888 15.0855 6.61941 15.0835 6.38184C15.0801 5.96763 15.0794 5.55334 15.084 5.13916C15.0851 5.039 15.0574 5.0061 14.958 5.00719C14.5137 5.01202 14.0693 5.0104 13.6249 5.00873C13.4371 5.00803 13.3091 4.9111 13.2455 4.72998C13.1911 4.57511 13.2396 4.395 13.3663 4.28223C13.452 4.20599 13.5551 4.18413 13.6639 4.18418C14.0834 4.18435 14.5029 4.18585 14.9224 4.18661C15.0774 4.18688 15.0821 4.18159 15.0821 4.01969C15.082 3.60545 15.0799 3.19119 15.0834 2.77698C15.0847 2.62122 15.141 2.48521 15.2852 2.41666C15.4323 2.34674 15.5822 2.34959 15.7191 2.45298C15.8255 2.53339 15.8641 2.64756 15.8641 2.77883C15.8644 3.20406 15.8672 3.62933 15.8623 4.05451C15.8611 4.15797 15.8972 4.18813 15.9919 4.18746C16.3972 4.18456 16.8025 4.18469 17.2077 4.18786C17.4253 4.18955 17.5714 4.30899 17.6195 4.51288C17.6795 4.76728 17.5027 5.00613 17.2466 5.00807C16.8378 5.01115 16.4289 5.00883 16.0201 5.00905C15.866 5.00913 15.8647 5.01078 15.8642 5.16771C15.864 5.25569 15.864 5.34367 15.8639 5.44265Z" fill="white"/>
                        <path d="M14.5731 0.0807198C15.9833 -0.168253 17.2666 0.157218 18.3757 1.07807C19.2393 1.79521 19.786 2.71956 19.9476 3.83711C20.216 5.69324 19.4563 7.5369 17.6696 8.54666C17.1462 8.84242 16.5864 9.04332 15.9833 9.11112C14.8468 9.23887 13.7813 9.01772 12.8255 8.34779C11.8533 7.6663 11.218 6.74958 10.9583 5.57067L10.9573 5.56565C10.7076 4.26944 10.9013 3.05143 11.6624 1.96092C12.3703 0.946758 13.3457 0.29751 14.5731 0.0807198ZM18.2696 1.20526C17.1988 0.316117 15.9656 0.00255992 14.6022 0.243278L14.3833 0.287623C13.3037 0.531702 12.439 1.13706 11.7977 2.05569L11.6664 2.2542C11.0435 3.25184 10.8923 4.3551 11.1196 5.53482C11.3699 6.67176 11.9805 7.55336 12.9203 8.21217C13.7819 8.81612 14.7359 9.04257 15.7593 8.96649L15.9649 8.94727C16.5426 8.88232 17.0812 8.68913 17.5886 8.4024C19.3108 7.42904 20.0438 5.65531 19.7843 3.86069C19.6386 2.85363 19.1685 2.00942 18.4229 1.3372L18.2696 1.20526ZM14.8917 1.08917C16.7734 0.811991 18.3946 1.97924 18.8396 3.68086C19.1039 4.69173 18.9349 5.6508 18.359 6.53019C17.7818 7.35916 17.0021 7.84002 16.0318 8.01143C15.5194 8.10191 15.0086 8.09375 14.5068 7.97215L14.2922 7.91347C13.599 7.69892 13.054 7.2881 12.6236 6.73074L12.4464 6.48358C12.2005 6.11449 12.0328 5.71061 11.9517 5.28141L11.922 5.09538C11.8279 4.36165 11.9109 3.65699 12.2379 3.00146L12.3936 2.72369C12.9739 1.78865 13.818 1.24733 14.8917 1.08917ZM18.68 3.72261C18.2557 2.09985 16.7112 0.98834 14.9156 1.25283C13.8893 1.40406 13.0884 1.91791 12.5342 2.81063C12.1028 3.5057 11.9827 4.26681 12.0863 5.07451C12.1469 5.54689 12.3159 5.99059 12.5834 6.39226C13.0212 7.04955 13.5911 7.5231 14.3411 7.75521C14.8844 7.92335 15.4413 7.9479 16.0034 7.84861C16.9315 7.68458 17.6718 7.22718 18.223 6.43545C18.7722 5.59487 18.9317 4.68513 18.68 3.72261ZM15.8641 2.77883C15.864 2.68046 15.8422 2.59149 15.7864 2.51936L15.7191 2.45298C15.5822 2.34959 15.4323 2.34674 15.2852 2.41666L15.235 2.44504C15.1277 2.51903 15.0846 2.64087 15.0834 2.77698C15.0799 3.19119 15.082 3.60545 15.0821 4.01969L15.0793 4.11432C15.0707 4.18389 15.0384 4.18681 14.9224 4.18661L13.6639 4.18418C13.5551 4.18413 13.452 4.20599 13.3663 4.28223C13.2396 4.395 13.1911 4.57511 13.2455 4.72998C13.3012 4.88861 13.4063 4.98282 13.5577 5.0042L13.6249 5.00873C14.0693 5.0104 14.5137 5.01202 14.958 5.00719L15.0201 5.01324C15.0694 5.02677 15.0848 5.06443 15.084 5.13916L15.0835 6.38184C15.0854 6.58938 15.207 6.73744 15.3857 6.76991L15.466 6.77677C15.7127 6.77442 15.8632 6.62442 15.8639 6.37744L15.8642 5.16771C15.8646 5.04989 15.8655 5.02006 15.931 5.01224L16.0201 5.00905L17.2466 5.00807C17.4704 5.00628 17.6341 4.82343 17.6315 4.60747L17.6195 4.51288C17.5714 4.30899 17.4253 4.18955 17.2077 4.18786L17.2086 4.02292C17.348 4.02401 17.477 4.06317 17.5802 4.14546C17.6834 4.2277 17.749 4.34306 17.7801 4.47489C17.8626 4.82461 17.618 5.17015 17.2478 5.17294C16.8414 5.17601 16.4338 5.17276 16.0295 5.17294V6.3782C16.029 6.53536 15.9794 6.68017 15.8738 6.78598C15.7684 6.89138 15.6244 6.94008 15.468 6.94166C15.3158 6.94311 15.1759 6.88883 15.0743 6.78497C14.9731 6.68135 14.9199 6.53908 14.9186 6.38322C14.9153 5.98017 14.9145 5.57662 14.9186 5.17294C14.4866 5.17726 14.0545 5.17555 13.624 5.17394C13.5009 5.17344 13.3866 5.1406 13.2905 5.06949C13.1952 4.99891 13.1299 4.89971 13.0896 4.78525C13.0121 4.56447 13.0818 4.31396 13.2564 4.15851C13.3838 4.04509 13.5336 4.01885 13.6642 4.0189L14.9166 4.01991C14.9166 3.60681 14.9141 3.19061 14.9176 2.77548C14.9193 2.58097 14.9936 2.37212 15.2139 2.26726C15.4084 2.1748 15.6256 2.17575 15.8186 2.3215C15.9784 2.44233 16.0293 2.61313 16.0295 2.77849C16.0297 3.19098 16.0319 3.60686 16.0275 4.02192C16.4212 4.01928 16.8149 4.01985 17.2086 4.02292L17.2077 4.18786C16.8025 4.18469 16.3972 4.18456 15.9919 4.18746L15.931 4.18161C15.898 4.17289 15.8782 4.15373 15.8688 4.11934L15.8623 4.05451C15.8672 3.62933 15.8644 3.20406 15.8641 2.77883Z" fill="white"/>
                      </svg>
                      <span style="color : #FFFFFF">Add Selected to Unit Cart </span>
                    </button>
                    <button 
                      class="btn btn-sm btn-outline-primary btn-view-cart" 
                      style="float : right;" 
                      @click="openCloseCart"
                      data-toggle="tooltip" 
                      data-placement="bottom" 
                      title="Buka unit cart"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20" fill="none">
                        <path d="M1.46248 0.45108C1.22811 0.526081 0.909358 0.830769 0.820295 1.06983C0.764045 1.21514 0.745295 1.36983 0.759358 1.59952C0.778108 1.98389 0.918733 2.23702 1.22811 2.43858L1.4203 2.56983L2.70467 2.58389C3.4078 2.59327 3.98436 2.61202 3.98436 2.63077C3.98436 2.65421 4.58436 5.27921 5.32029 8.47608L6.65623 14.2792L6.29998 15.2214C5.86405 16.3698 5.79842 16.7448 5.9203 17.3589C6.03748 17.9589 6.26248 18.3855 6.69373 18.8073C6.94217 19.0558 7.15311 19.2151 7.36873 19.3183C7.98748 19.6183 7.79998 19.6136 13.6312 19.5995L18.9234 19.5855L19.1531 19.4448C19.2937 19.3558 19.4344 19.2151 19.5234 19.0745C19.6453 18.873 19.664 18.798 19.664 18.512C19.6594 18.1417 19.5656 17.9026 19.3265 17.6776C19.0265 17.3917 19.3312 17.4058 13.7484 17.4058C10.3969 17.4058 8.58748 17.387 8.47498 17.3589C8.26405 17.298 8.10936 17.1151 8.10936 16.9183C8.10936 16.8386 8.21717 16.4823 8.34842 16.1308L8.58748 15.4886L13.9406 15.4745C19.9172 15.4558 19.425 15.4839 20.1187 15.123C20.6437 14.8464 21.1172 14.3167 21.3281 13.7589C21.3797 13.6276 21.8297 11.7386 22.3359 9.56358C23.1844 5.88858 23.25 5.57452 23.25 5.15733C23.25 3.96202 22.5328 2.97296 21.375 2.57921L21.0703 2.47608L13.6453 2.45264L6.22498 2.42921L6.11248 1.98858C5.94842 1.33702 5.67186 0.933893 5.19842 0.657331C4.79061 0.418268 4.55623 0.390142 3.02342 0.394831C2.18436 0.399517 1.55623 0.418268 1.46248 0.45108ZM20.8875 4.86202C20.9765 4.95108 21.0469 5.06827 21.0469 5.12452C21.0469 5.23233 19.4109 12.362 19.289 12.798C19.2469 12.948 19.1719 13.0792 19.0969 13.1355C18.9703 13.2339 18.9656 13.2339 13.8375 13.2245L8.69998 13.2105L7.72498 8.99171C7.19061 6.67139 6.75467 4.75889 6.74998 4.73546C6.74998 4.71671 9.89529 4.70264 13.739 4.70264H20.7281L20.8875 4.86202Z" fill="#3098F7"/>
                        <path d="M9.94219 6.6387C9.70781 6.72776 9.42187 6.99026 9.32344 7.20589C9.24375 7.37933 9.23438 7.5387 9.23438 8.95901C9.23438 10.6559 9.24375 10.7215 9.50625 10.9981C9.71719 11.2231 9.97031 11.3262 10.3125 11.3309C10.6547 11.3356 10.8891 11.2418 11.1141 11.0168C11.4187 10.7121 11.4141 10.7496 11.4141 8.9637V7.34183L11.2734 7.11214C11.0719 6.79339 10.7812 6.61995 10.3969 6.59651C10.2281 6.58714 10.0359 6.60589 9.94219 6.6387Z" fill="#3098F7"/>
                        <path d="M13.3641 6.63888C13.1391 6.72795 12.8578 6.97638 12.7359 7.20138C12.6375 7.39357 12.6328 7.43576 12.6328 8.9217C12.6328 10.5858 12.6422 10.6748 12.9047 10.9654C13.3172 11.4389 14.0062 11.4764 14.4797 11.0498C14.8547 10.7123 14.8687 10.6514 14.85 8.86545L14.8359 7.34201L14.6953 7.11232C14.4937 6.79357 14.2031 6.62013 13.8187 6.5967C13.65 6.58732 13.4578 6.60607 13.3641 6.63888Z" fill="#3098F7"/>
                        <path d="M16.7859 6.63864C16.5609 6.7277 16.2797 6.97614 16.1578 7.20114C16.0594 7.39332 16.0547 7.43551 16.0547 8.92145C16.0547 10.5855 16.0641 10.6746 16.3266 10.9652C16.6031 11.2839 17.0203 11.4105 17.4422 11.3121C17.7797 11.2324 18.1453 10.8761 18.225 10.5527C18.3141 10.2058 18.3 7.58551 18.2109 7.33239C18.1125 7.04645 17.9766 6.8777 17.7375 6.73707C17.4891 6.59176 17.0344 6.54489 16.7859 6.63864Z" fill="#3098F7"/>
                      </svg>
                      <span style="color : #2E3646">Unit Cart </span>
                      <span class="badge" v-if="cartCount > 0">{{cartCount}}</span>
                    </button>
                  </div>
              </div>

              <table class="table table-sm table-bordered table-striped table-responsive-sm mt-2">
                <thead class="">
                  <tr>
                    <th style=" text-align: center;"> 
                      <input type="checkbox" @change="selectAllRows" :checked="checkIsSelectAll()" :disabled="checkIsDisableSelectAll()">
                    </th>
                    <th class="table-field-name">Order Details</th>
                    <th class="table-field-name" style="max-width : 12.5em;">Product Details</th>
                    <th class="table-field-name" style="max-width : 11em;">Product Code</th>
                    <th class="table-field-name">Start Rent</th>
                    <th class="table-field-name">End Rent</th>
                    <th class="table-field-name">Prorate</th>
                    <th class="table-field-name">Status</th>
                    <th class="table-field-name">Action</th>
                  </tr>
                </thead>
                <tbody v-if="loadingTable == true">
                  <tr>
                    <td colspan="9" class="text-center"><img src="~@/assets/images/load-button.gif" /></td>
                  </tr>
                </tbody>
                <tbody v-else-if="loadingTable == false && totalData == 0">
                  <!-- <tr v-else-if="loadingTable == false && totalData == 0"> -->
                  <tr>
                    <td colspan="9" class="text-center">Data not available</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="data in dataInsurance" :key="data.id">
                  <!-- <tr v-for="data in dataInsurance" :key="data.orderDetailsId" v-else> -->
                    <td style=" text-align: center;">
                      <input type="checkbox" v-model="selectedRows" :value="data" :disabled="dataCart.find(el => el.itemId == data.id)">
                    </td>
                    <td style="text-align: left;"> 
                       {{data.orderGroupHash}} <br />
                      <b>{{data.companyName}}</b>
                      <!-- <br />
                      Start : {{data.startRent}} <br />
                      End : {{data.endRent}} -->
                    </td>
                    <td style="text-align: left; max-width :200px; "> 
                      {{`${data.brand} ${data.model}`}}<br/>
                      {{data.specifications}}
                    </td>
                    <td>{{data.orderCode}}</td>
                    <td>{{data.startRent}}</td>
                    <td>{{data.endRent}}</td>
                    <td>{{data.prorate}}</td>
                    <td class="text-center">
                      <span
                      :class="data.status == 'pending' ? 'item-pending-badge' : 'item-no-issue-badge'"
                      :style="data.status == 'pending' ? 'background-color: rgba(254, 244, 234, 1);' : 'background-color: rgba(234, 234, 234, 1);'"
                      >
                        {{data.status}}
                      </span>
                    </td>
                    <td class="text-center">
                      <div v-if="data.status == 'pending'">
                        <button class="btn btn-sm btn-outline-primary btn-add-cart"  data-toggle="tooltip" data-placement="bottom" title="Add to cart" @click="addToCart([data.id],false)" v-if="!dataCart.find(el => el.itemId == data.id)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M0.0450271 2.83383C0.106334 2.66926 0.325748 2.45953 0.487081 2.4079C0.551615 2.38532 0.983989 2.37241 1.56156 2.36918C2.61668 2.36596 2.77802 2.38532 3.05874 2.54988C3.38463 2.74025 3.57501 3.01775 3.68794 3.46625L3.76538 3.76956L8.8732 3.78569L9.36658 3.78992C10.1741 4.0218 10.1741 5.12375 9.36658 5.3345L8.93773 5.3345C6.29186 5.3345 4.12677 5.34418 4.12677 5.35708C4.12999 5.37322 4.43007 6.6897 4.79791 8.2869L5.46906 11.1909L9.00549 11.2006C12.5355 11.207 12.5387 11.207 12.6258 11.1393C12.6774 11.1006 12.7291 11.0102 12.7581 10.907C12.7796 10.83 12.9044 10.6053 13.0465 10.1714C13.1731 9.78491 13.4822 9.42958 13.8818 9.50532C14.0575 9.53864 14.219 9.6056 14.3748 9.69819C14.7104 9.8976 14.8256 10.3204 14.7155 10.6949C14.5168 11.3711 14.348 11.678 14.3254 11.7355C14.1802 12.1194 13.9202 12.3848 13.5589 12.5751C13.0813 12.8236 13.1905 12.7365 9.07648 12.7494L5.39162 12.7591L5.22706 13.2011C5.13672 13.4431 5.0625 13.6884 5.0625 13.7432C5.0625 13.8787 5.16898 14.0046 5.31418 14.0465C5.39162 14.0659 6.63712 14.0788 8.94419 14.0788C12.7872 14.0788 12.5774 14.0691 12.7839 14.2659C12.9485 14.4208 13.013 14.5854 13.0162 14.8403C13.0162 15.0371 13.0033 15.0887 12.9194 15.2275C12.8581 15.3243 12.7613 15.4211 12.6645 15.4824L12.5064 15.5792L8.86352 15.5889C4.84954 15.5985 4.97861 15.6018 4.55269 15.3953C4.40426 15.3243 4.25906 15.2146 4.08805 15.0436C3.79119 14.7532 3.63631 14.4595 3.55565 14.0465C3.47175 13.6238 3.51693 13.3657 3.81701 12.5751L4.06223 11.9266L3.14263 7.93197C2.63604 5.73138 2.22303 3.92444 2.22303 3.90831C2.22303 3.8954 1.82615 3.88249 1.34215 3.87604L0.458041 3.86636L0.325748 3.77601C0.112787 3.63727 0.0159871 3.46303 0.00308039 3.19844C-0.00659962 3.04033 0.00630706 2.93385 0.0450271 2.83383Z" fill="#1C68D9"/>
                            <path d="M7.09904 6.66717C6.93771 6.72848 6.74088 6.90917 6.67312 7.0576C6.61827 7.17699 6.61182 7.28669 6.61182 8.26438C6.61182 9.43243 6.61827 9.4776 6.79896 9.66798C6.94416 9.82286 7.1184 9.89384 7.35395 9.89707C7.5895 9.9003 7.75083 9.83576 7.90571 9.68088C8.11545 9.47115 8.11222 9.49696 8.11222 8.2676V7.15117L8.01542 6.99307C7.87667 6.77365 7.67662 6.65427 7.41203 6.63813C7.29587 6.63168 7.16358 6.64459 7.09904 6.66717Z" fill="#1C68D9"/>
                            <path d="M9.78119 6.66735C9.62631 6.72865 9.43271 6.89967 9.34882 7.05455C9.28106 7.18684 9.27783 7.21588 9.27783 8.23874C9.27783 9.3842 9.28429 9.44551 9.46498 9.64556C9.74893 9.97146 10.2232 9.99727 10.5491 9.70364C10.8073 9.47132 10.817 9.42938 10.804 8.20002L10.7944 7.15135L10.6976 6.99324C10.5588 6.77383 10.3588 6.65444 10.0942 6.63831C9.97802 6.63185 9.84573 6.64476 9.78119 6.66735Z" fill="#1C68D9"/>
                            <path d="M11.1196 5.53482C10.8771 4.27619 11.0655 3.10489 11.7977 2.05569C12.4818 1.07556 13.4198 0.452022 14.6022 0.243278C15.9656 0.00255992 17.1988 0.316117 18.2696 1.20526C19.1041 1.89805 19.6289 2.78617 19.7843 3.86069C20.0438 5.65531 19.3108 7.42904 17.5886 8.4024C17.0812 8.68913 16.5426 8.88232 15.9649 8.94727C14.8635 9.07108 13.8393 8.85638 12.9203 8.21217C11.9805 7.55336 11.3699 6.67176 11.1196 5.53482ZM18.359 6.53019C18.9349 5.6508 19.1039 4.69173 18.8396 3.68086C18.3946 1.97924 16.7734 0.811991 14.8917 1.08917C13.818 1.24733 12.9739 1.78865 12.3936 2.72369C11.9387 3.45644 11.8144 4.2568 11.922 5.09538C11.986 5.59419 12.1653 6.06159 12.4464 6.48358C12.9016 7.16706 13.5001 7.66834 14.2922 7.91347C14.8627 8.09004 15.4461 8.1149 16.0318 8.01143C17.0021 7.84002 17.7818 7.35916 18.359 6.53019Z" fill="#1C68D9"/>
                            <path d="M15.8639 5.44265C15.864 5.76158 15.8648 6.06951 15.8639 6.37744C15.8632 6.62442 15.7127 6.77442 15.466 6.77677C15.2443 6.77888 15.0855 6.61941 15.0835 6.38184C15.0801 5.96763 15.0794 5.55334 15.084 5.13916C15.0851 5.039 15.0574 5.0061 14.958 5.00719C14.5137 5.01202 14.0693 5.0104 13.6249 5.00873C13.4371 5.00803 13.3091 4.9111 13.2455 4.72998C13.1911 4.57511 13.2396 4.395 13.3663 4.28223C13.452 4.20599 13.5551 4.18413 13.6639 4.18418C14.0834 4.18435 14.5029 4.18585 14.9224 4.18661C15.0774 4.18688 15.0821 4.18159 15.0821 4.01969C15.082 3.60545 15.0799 3.19119 15.0834 2.77698C15.0847 2.62122 15.141 2.48521 15.2852 2.41666C15.4323 2.34674 15.5822 2.34959 15.7191 2.45298C15.8255 2.53339 15.8641 2.64756 15.8641 2.77883C15.8644 3.20406 15.8672 3.62933 15.8623 4.05451C15.8611 4.15797 15.8972 4.18813 15.9919 4.18746C16.3972 4.18456 16.8025 4.18469 17.2077 4.18786C17.4253 4.18955 17.5714 4.30899 17.6195 4.51288C17.6795 4.76728 17.5027 5.00613 17.2466 5.00807C16.8378 5.01115 16.4289 5.00883 16.0201 5.00905C15.866 5.00913 15.8647 5.01078 15.8642 5.16771C15.864 5.25569 15.864 5.34367 15.8639 5.44265Z" fill="#1C68D9"/>
                            <path d="M14.5731 0.0807198C15.9833 -0.168253 17.2666 0.157218 18.3757 1.07807C19.2393 1.79521 19.786 2.71956 19.9476 3.83711C20.216 5.69324 19.4563 7.5369 17.6696 8.54666C17.1462 8.84242 16.5864 9.04332 15.9833 9.11112C14.8468 9.23887 13.7813 9.01772 12.8255 8.34779C11.8533 7.6663 11.218 6.74958 10.9583 5.57067L10.9573 5.56565C10.7076 4.26944 10.9013 3.05143 11.6624 1.96092C12.3703 0.946758 13.3457 0.29751 14.5731 0.0807198ZM18.2696 1.20526C17.1988 0.316117 15.9656 0.00255992 14.6022 0.243278L14.3833 0.287623C13.3037 0.531702 12.439 1.13706 11.7977 2.05569L11.6664 2.2542C11.0435 3.25184 10.8923 4.3551 11.1196 5.53482C11.3699 6.67176 11.9805 7.55336 12.9203 8.21217C13.7819 8.81612 14.7359 9.04257 15.7593 8.96649L15.9649 8.94727C16.5426 8.88232 17.0812 8.68913 17.5886 8.4024C19.3108 7.42904 20.0438 5.65531 19.7843 3.86069C19.6386 2.85363 19.1685 2.00942 18.4229 1.3372L18.2696 1.20526ZM14.8917 1.08917C16.7734 0.811991 18.3946 1.97924 18.8396 3.68086C19.1039 4.69173 18.9349 5.6508 18.359 6.53019C17.7818 7.35916 17.0021 7.84002 16.0318 8.01143C15.5194 8.10191 15.0086 8.09375 14.5068 7.97215L14.2922 7.91347C13.599 7.69892 13.054 7.2881 12.6236 6.73074L12.4464 6.48358C12.2005 6.11449 12.0328 5.71061 11.9517 5.28141L11.922 5.09538C11.8279 4.36165 11.9109 3.65699 12.2379 3.00146L12.3936 2.72369C12.9739 1.78865 13.818 1.24733 14.8917 1.08917ZM18.68 3.72261C18.2557 2.09985 16.7112 0.98834 14.9156 1.25283C13.8893 1.40406 13.0884 1.91791 12.5342 2.81063C12.1028 3.5057 11.9827 4.26681 12.0863 5.07451C12.1469 5.54689 12.3159 5.99059 12.5834 6.39226C13.0212 7.04955 13.5911 7.5231 14.3411 7.75521C14.8844 7.92335 15.4413 7.9479 16.0034 7.84861C16.9315 7.68458 17.6718 7.22718 18.223 6.43545C18.7722 5.59487 18.9317 4.68513 18.68 3.72261ZM15.8641 2.77883C15.864 2.68046 15.8422 2.59149 15.7864 2.51936L15.7191 2.45298C15.5822 2.34959 15.4323 2.34674 15.2852 2.41666L15.235 2.44504C15.1277 2.51903 15.0846 2.64087 15.0834 2.77698C15.0799 3.19119 15.082 3.60545 15.0821 4.01969L15.0793 4.11432C15.0707 4.18389 15.0384 4.18681 14.9224 4.18661L13.6639 4.18418C13.5551 4.18413 13.452 4.20599 13.3663 4.28223C13.2396 4.395 13.1911 4.57511 13.2455 4.72998C13.3012 4.88861 13.4063 4.98282 13.5577 5.0042L13.6249 5.00873C14.0693 5.0104 14.5137 5.01202 14.958 5.00719L15.0201 5.01324C15.0694 5.02677 15.0848 5.06443 15.084 5.13916L15.0835 6.38184C15.0854 6.58938 15.207 6.73744 15.3857 6.76991L15.466 6.77677C15.7127 6.77442 15.8632 6.62442 15.8639 6.37744L15.8642 5.16771C15.8646 5.04989 15.8655 5.02006 15.931 5.01224L16.0201 5.00905L17.2466 5.00807C17.4704 5.00628 17.6341 4.82343 17.6315 4.60747L17.6195 4.51288C17.5714 4.30899 17.4253 4.18955 17.2077 4.18786L17.2086 4.02292C17.348 4.02401 17.477 4.06317 17.5802 4.14546C17.6834 4.2277 17.749 4.34306 17.7801 4.47489C17.8626 4.82461 17.618 5.17015 17.2478 5.17294C16.8414 5.17601 16.4338 5.17276 16.0295 5.17294V6.3782C16.029 6.53536 15.9794 6.68017 15.8738 6.78598C15.7684 6.89138 15.6244 6.94008 15.468 6.94166C15.3158 6.94311 15.1759 6.88883 15.0743 6.78497C14.9731 6.68135 14.9199 6.53908 14.9186 6.38322C14.9153 5.98017 14.9145 5.57662 14.9186 5.17294C14.4866 5.17726 14.0545 5.17555 13.624 5.17394C13.5009 5.17344 13.3866 5.1406 13.2905 5.06949C13.1952 4.99891 13.1299 4.89971 13.0896 4.78525C13.0121 4.56447 13.0818 4.31396 13.2564 4.15851C13.3838 4.04509 13.5336 4.01885 13.6642 4.0189L14.9166 4.01991C14.9166 3.60681 14.9141 3.19061 14.9176 2.77548C14.9193 2.58097 14.9936 2.37212 15.2139 2.26726C15.4084 2.1748 15.6256 2.17575 15.8186 2.3215C15.9784 2.44233 16.0293 2.61313 16.0295 2.77849C16.0297 3.19098 16.0319 3.60686 16.0275 4.02192C16.4212 4.01928 16.8149 4.01985 17.2086 4.02292L17.2077 4.18786C16.8025 4.18469 16.3972 4.18456 15.9919 4.18746L15.931 4.18161C15.898 4.17289 15.8782 4.15373 15.8688 4.11934L15.8623 4.05451C15.8672 3.62933 15.8644 3.20406 15.8641 2.77883Z" fill="#1C68D9"/>
                          </svg>
                        </button>
                        <button class="btn btn-sm btn-outline-warning btn-remove-cart"  data-toggle="tooltip" data-placement="bottom" title="Remove from cart" @click="removeFromCart(data.id)" v-else>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M3.94195 0.068121C4.20875 0.205688 4.388 0.451643 4.43803 0.747622C4.4547 0.826827 4.42969 1.09362 4.388 1.33958C4.34214 1.5897 4.31296 1.7898 4.31713 1.7898C4.3213 1.7898 4.5214 1.69809 4.75902 1.58553C7.35612 0.368269 10.3951 0.726777 12.6962 2.51932C13.1381 2.86116 13.7926 3.55317 14.147 4.04507C14.4846 4.51614 14.9515 5.42909 15.1308 5.96685C15.8353 8.08039 15.6227 10.3357 14.543 12.2241C13.6926 13.7123 12.3044 14.9004 10.6744 15.5299C9.89904 15.8259 9.17785 15.9634 8.23155 15.9926C7.33111 16.0218 6.81836 15.9676 6.06799 15.7758C4.75068 15.4382 3.70433 14.8504 2.71635 13.8999C1.80757 13.0245 1.17809 12.0407 0.798738 10.8943C0.631989 10.4024 0.461072 9.65616 0.461072 9.43939C0.461072 9.09339 0.744544 8.68902 1.06554 8.5848C1.31983 8.50143 1.6825 8.54729 1.88677 8.69319C2.12439 8.85994 2.23278 9.06421 2.31198 9.50609C2.71218 11.6988 4.44219 13.5122 6.63077 14.0375C8.18153 14.4127 9.82817 14.1167 11.1663 13.2246C11.6291 12.9161 12.3044 12.2658 12.6337 11.8072C12.9547 11.357 13.3424 10.5649 13.4883 10.0647C14.1511 7.76357 13.3341 5.29569 11.429 3.86165C10.4618 3.13213 9.4113 2.76528 8.16902 2.71942C7.16853 2.6819 6.45985 2.82781 5.57192 3.24051L5.16338 3.43227L5.82204 3.549C6.36814 3.64071 6.50988 3.6824 6.64744 3.77828C7.13518 4.12428 7.13101 4.90383 6.63911 5.26234C6.35563 5.47077 6.20556 5.46244 4.35882 5.14561C3.46671 4.99554 2.67049 4.8413 2.59545 4.80378C2.39536 4.7079 2.18275 4.4411 2.12856 4.20765C2.08687 4.03674 2.09938 3.89917 2.23278 3.11962C2.57461 1.09779 2.67466 0.572536 2.72885 0.464149C2.80806 0.309906 3.04151 0.0931339 3.18324 0.0431089C3.35833 -0.0235901 3.79604 -0.0110855 3.94195 0.068121Z" fill="#F78F30"/>
                            </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div id="wrapperr">
                <div id="c1" style="display: inline-flex;">
                  <div style="margin-right: 10px;">
                    <select class="form-control form-control-sm" v-model="itemPerPage" @change="searchData()">
                      <option value="10">10</option>
                      <option value="40">40</option>
                      <option value="80">80</option>
                    </select>
                  </div>
                  <div class="alignLeft total-data">
                    Total Data {{ totalData }}
                  </div>
                </div>
                <div id="c2">
                  <div class="pagination p8 alignRight">
                    <ul>
                      <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1">
                        <li>
                          {{'<'}}</li> </a> <a class="page">
                        <li>{{ currentPage }} of {{ totalPage }} page</li>
                      </a>
                      <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage">
                        <li>></li>
                      </a>
                    </ul>
                  </div>
                </div>
              </div>
              ​
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /#page-content-wrapper -->

  </div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Swal from 'sweetalert2';
import SideBar from "../SideBar";
import { Money } from "v-money";
import CartDrawer from './CustomComponent/CartDrawer.vue'
export default {
  name: "insurancePendingDeclareListPage",
  components: {
    SideBar,
    Multiselect,
    Money,
    CartDrawer,
  },
  data() {
    return {
      loadingTable: false,
      loadingCart : false,
      loadingCreateBatch : false,
      openCart : false,
      cartCount : 0,
      batchInsuranceOptions : [
        {
          batchName : '1111'
        },
        {
          batchName : '2222'
        }
      ],
      insuranceStatusOptions: [
        {
          statusName: "All",
        },
        {
          statusName: "Pending",
        },
        {
          statusName: "No Issue",
        },
      ],
      // searchInsuranceBatch :'',
      searchOrderCode : '',
      searchLesseeName :'',
      searchProductCode:'',
      searchInsuranceStatus: {
          statusName : 'Pending'
        },
      searchStartRentFrom:'',
      searchStartRentTo:'',
      searchEndRentFrom:'',
      searchEndRentTo:'',
      source: "",
      admin: "",
      permission: [],
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      itemPerPage: 10,
      dataInsurance: [],
      dataCart :[],
      dataVendor : [],
      token: localStorage.getItem("jwt"),
      password: "",
      disableSave: false,
      showErrorUnit : false,
      errorUnitList : [],
      selectedRows : [],
    };
  },
  watch: {
    selectedRows: function (a) {
      localStorage.setItem("selectedPendingInsurance", JSON.stringify(a));
    },
  },
  methods: {
    checkIsDisableSelectAll() {
      let dataInCartCount = this.dataInsurance.filter(data => this.dataCart.find(item => item.itemId == data.id))
      return this.dataInsurance.length == dataInCartCount.length
    },
    checkIsSelectAll() {
     
      let checked = 0
      let dataInCartCount = this.dataInsurance.filter(data => this.dataCart.find(item => item.itemId == data.id))
      // let datas = this.dataInsurance.filter(data => this.dataCart.find(item => item.itemId !== data.id))
      this.dataInsurance.forEach(data => {
      // datas.forEach(data => {
        if(this.selectedRows.find(item => item.id == data.id)) {
          checked += 1
        }
      })

      // if( this.dataInsurance.length > 0 && checked == this.dataInsurance.length) {
      let comparisonLength = this.dataInsurance.length - dataInCartCount.length
      if( this.dataInsurance.length > 0 && checked == comparisonLength) {
        return true
      } else {
        return false
      }
    },
    selectAllRows() {
      const isSelectAll = this.checkIsSelectAll()
      let datas = this.dataInsurance
      // let datas = this.dataInsurance.filter(data => this.dataCart.find(item => item.itemId !== data.id))
      if (!isSelectAll) {
        datas.forEach(item => {
          if(!this.selectedRows.find(data => data.id == item.id) && !this.dataCart.find(data => data.itemId == item.id)) {
            this.selectedRows.push(item)
          }
        })
        localStorage.setItem("selectedPendingInsurance", JSON.stringify(this.selectedRows))
      } else {
       datas.forEach(item => {
          const index = this.selectedRows.findIndex(data => item.id == data.id); 
          if(this.selectedRows.find(data => item.id == data.id)) {
            this.selectedRows.splice(index, 1);
          }
        })
        localStorage.setItem("selectedPendingInsurance", JSON.stringify(this.selectedRows))
      }
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if(['22','22.1', '22.2', '22.3'].includes(this.permission[i])) {
          this.viewNewInsurance = true
        }
        if(this.permission[i] == '22.1') {
          this.viewNewInsuranceVendor = true
        }
        if(this.permission[i] == '22.2') {
          this.viewNewInsurancePendingDeclare = true
        }
        if(this.permission[i] == '22.3') {
          this.viewNewInsuranceBatch = true
        }

        if (this.viewNewInsurancePendingDeclare == false) {
          this.$router.push('/')
        }
      }
    },
    getCartItemList() {
      this.loadingCart = true;
      this.$http
      .post(
        process.env.GET_INSURANCE_CART_ITEM_LIST, {
          page: 1,
          itemPerPage: 2000,    
        }, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        }
      )
      .then((response) => {
          this.dataCart = response.data.data.data ? response.data.data.data : [];
          this.cartCount = this.dataCart.length
          this.loadingCart = false;
        })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        });
      });
    },
    bulkAddToCart() {
      let itemAdded = JSON.parse(localStorage.getItem('selectedPendingInsurance')).map(item => {
        return item.id
      })

      this.addToCart(itemAdded,true)
    },
    addToCart(ids, isBulk) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      this.$http
      .post(
          process.env.ADD_TO_INSURANCE_CART, {
           itemIds : ids,
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
      .then((response) => {
        if(response.status == 200 && response.data.status == 200) {
          this.dataInsurance = [...this.dataInsurance]
          if(isBulk) {
            this.selectedRows = []
            localStorage.setItem('selectedPendingInsurance',JSON.stringify(this.selectedRows))
            swalWithBootstrapButtons.fire({
                title: "Success",
                text: 'Berhasil menambahkan unit ke dalam cart',
                icon: "success"
            }).then(result => {
              if(result.isConfirmed) {
                this.getData();
                this.getCartItemList()
                this.checkIsDisableSelectAll()
              }
            })
          } else {
            this.getData();
            this.getCartItemList()
            this.checkIsDisableSelectAll()
          }
          
        } else {
          swalWithBootstrapButtons.fire({
              title: "Failed",
              text: `${response.data.message}`,
              icon: "error"
          }).then(result => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        }
        
        
      })
      .catch(error => {
        swalWithBootstrapButtons.fire({
              title: "Failed",
              text: `${error}`,
              icon: "error"
        }).then(result => {
          if(result.isConfirmed) {
                
          }
        })
      });
    },
    bulkRemoveFromCart() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      const removedItems = JSON.parse(localStorage.getItem('selectedInsuranceCartItem')).map(item => item.id)
      this.$http
      .post(
          `${process.env.REMOVE_FROM_INSURANCE_CART}`, {
           cartIds : removedItems,
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
      .then((response) => {
        if(response.status == 200 && response.data.status == 200) {
        this.dataInsurance = [...this.dataInsurance]
        this.getData();
        this.getCartItemList()
        this.checkIsDisableSelectAll()
        } else {
          swalWithBootstrapButtons.fire({
              title: "Failed",
              text: `${response.data.message}`,
              icon: "error"
          }).then(result => {
            if(result.isConfirmed) {
                  
            }
          })
        }
      })
      .catch(error => {
        swalWithBootstrapButtons.fire({
              title: "Failed",
              text: `${error}`,
              icon: "error"
        }).then(result => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      });
    },
    removeFromCart(id) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      const itemToRemove = this.dataCart.find(el => el.itemId == id)
      this.$http
      .post(
          `${process.env.REMOVE_FROM_INSURANCE_CART}`, {
           cartIds : [itemToRemove.id],
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
      .then((response) => {
        if(response.status == 200 && response.data.status == 200) {
        this.dataInsurance = [...this.dataInsurance]
        this.getData();
        this.getCartItemList()
        this.checkIsDisableSelectAll()
        } else {
          swalWithBootstrapButtons.fire({
              title: "Failed",
              text: `${response.data.message}`,
              icon: "error"
          }).then(result => {
            if(result.isConfirmed) {
              this.checkIsDisableSelectAll()
            }
          })
        }
      })
      .catch(error => {
        swalWithBootstrapButtons.fire({
              title: "Failed",
              text: `${error}`,
              icon: "error"
        }).then(result => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      });
    },
    createBatch(selectedVendor, notIssued) {
      this.showErrorUnit = false
      this.errorUnitList = []
      this.loadingCreateBatch = true;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      const submittedData = JSON.parse(localStorage.getItem('selectedInsuranceCartItem')).map(item => item.id)

      this.$http
      .post(
          `${process.env.CREATE_BATCH_INSURANCE}`, {
           partnerId : selectedVendor.id,
           cartIds: submittedData,
           notIssued : notIssued,
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
      .then((response) => {
          // if(response.status == 200 && response.data.status == 200) {
          if(response.status == 200) {
            if(response.data.status == 200) {
              swalWithBootstrapButtons.fire({
                title: "Success",
                text: notIssued ? 'Status Unit berhasil diubah' : 'Unit berhasil dipindahkan ke menu Batch Insurance',
                icon: "success"
              }).then(result => {
                if(result.isConfirmed) {
                  this.openCloseCart()
                  this.getData()
                  this.getCartItemList()
                  localStorage.setItem('selectedInsuranceCartItem', JSON.stringify([]))
                }
              })
            } else if(response.data.status == 406 ) {
              swalWithBootstrapButtons.fire({
                 title: `<strong style='font-size : 24px; font-weight : 600;'>Gagal Buat Batch'</strong>`,
                icon: "warning",
                width: '32rem',
                html: `
                    <div style="max-width : 100%">
                      <span style="color : rgba(86, 86, 86, 1);font-size: 16px;"> 
                        Beberapa unit tidak dapat di deklarasi dikarenakan sudah masuk ke Batch/Cart lain' 
                      </span>
                      <br/><br/>
                      <span style="color : rgba(240, 100, 0, 1);font-size: 16px;"> ${!notIssued ? 
                        'Silahkan Buat Batch kembali setelah unit yang bermasalah dikeluarkan dari Unit Cart' 
                        : 'Silahkan submit kembali setelah unit yang bermasalah dikeluarkan dari Unit Cart'
                      }</span>
                    </div>
                  `,
                reverseButtons: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: `Keluarkan Unit Bermasalah`,
                cancelButtonText: `Batalkan`,
              }).then(result => {
                if(result.isConfirmed) {
                  this.showErrorUnit = true
                  this.errorUnitList = response.data.data.cartIds
                } else {
                  this.showErrorUnit = false
                }
              })
            } else {
              swalWithBootstrapButtons.fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error"
              })
            }
          } 
      })
      .catch(error => {
        swalWithBootstrapButtons.fire({
          title: "Failed",
          text: `${error}`,
          icon: "error"
        }).then(result => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      });
    },
    getActiveVendor(){
      const currentDate = new Date()
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      this.$http
        .post(
          process.env.GET_VENDOR_LIST, {
            keyword: '',
            page: 1,
            itemPerPage: 1000,
            status : 'active',
            currentDate : `${currentDate.getFullYear()}-${currentDate.getMonth()+1 < 10 ? `0${currentDate.getMonth()+1}` : currentDate.getMonth()+1}-${currentDate.getDate() < 10 ? `0${currentDate.getDate()}` : currentDate.getDate()}`
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if(response.status == 200 && response.data.status == 200) {   
            this.dataVendor = response.data.data.data ? response.data.data.data.filter(item => item.active == true) : []
          } else {
            swalWithBootstrapButtons.fire({
              title: "Failed",
              text: `${response.data.message}`,
              icon: "error"
            }).then(result => {
              if(result.isConfirmed) {
                    
              }
            })
          }
        })
        .catch(error => {
          swalWithBootstrapButtons.fire({
              title: "Failed",
              text: `${error}`,
              icon: "error"
          }).then(result => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    openCloseCart() {
      this.getCartItemList()
      // this.getData()
      this.errorUnitList = []
      this.showErrorUnit = false
      this.openCart = this.openCart ? false : true;
    },
    sendLog(w, x) {
      // var today = new Date();
      // var month = today.getMonth()+1
      // if (month < 10) {
      //     month = '0'+month
      // }
      // var dateDay = today.getDate()
      // if (dateDay < 10) {
      //     dateDay = '0'+dateDay
      // }
      // var hours = today.getHours()
      // if (hours < 10) {
      //     hours = '0'+hours
      // }
      // var minutes = today.getMinutes()
      // if (minutes < 10) {
      //     minutes = '0'+minutes
      // }
      // var second = today.getSeconds()
      // if (second < 10) {
      //     second = '0'+second
      // }
      // var date = today.getFullYear()+'-'+month+'-'+dateDay;
      // var time = hours + ":" + minutes + ":" + second;
      // var dateTime = date+' '+time;
      // var admin = this.admin
      // var command = 'add-logs'
      // // var productName = this.productNameChoose
      // this.$http.post(process.env.LOG_URL+"/company/"+x,{
      //     codeLogs: w,
      //     params: [],
      // },{
      //     headers: {'Asani-Token':localStorage.getItem('jwt')}
      // })
      // .then(response => {
      // })
      // .catch(error => {
      //     console.log(error)
      // })
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    resetFilter() {
      // this.searchInsuranceBatch = '';
      this.searchLesseeName= '';
      this.searchProductCode= '';
      this.searchOrderCode = '';
      this.searchStartRentFrom= '';
      this.searchStartRentTo= '';
      this.searchEndRentFrom= '';
      this.searchEndRentTo= '';
      this.searchInsuranceStatus = '';

      this.$router.push({
        path: "/insurance/pending",
        query: {
          page: 1,
          itemPerPage: 10,
          // batchOrder: this.searchInsuranceBatch ? this.searchInsuranceBatch.batchName : '',
          batchOrder : '',
          orderCode: this.searchOrderCode,
          lesseeName: this.searchLesseeName,
          productCode: this.searchProductCode,
          startRentFrom : this.searchStartRentFrom,
          startRentTo : this.searchStartRentTo,
          endRentFrom : this.searchEndRentFrom,
          endRentTo : this.searchEndRentTo,
          status: this.searchInsuranceStatus ?  this.searchInsuranceStatus.statusName : '',
        },
      });
    },
    searchData() {
      this.$router.push({
        path: "/insurance/pending",
        query: {
          page: 1,
          itemPerPage: this.itemPerPage,
          // batchOrder: this.searchInsuranceBatch ? this.searchInsuranceBatch.batchName : '',
          batchOrder : '',
          orderCode: this.searchOrderCode,
          lesseeName: this.searchLesseeName,
          productCode: this.searchProductCode,
          startRentFrom : this.searchStartRentFrom,
          startRentTo : this.searchStartRentTo,
          endRentFrom : this.searchEndRentFrom,
          endRentTo : this.searchEndRentTo,
          status: this.searchInsuranceStatus ? this.searchInsuranceStatus.statusName : ''
        },
      });
    },
    toDataPage(pagePost) {
      this.$router.push({
        path: "/insurance/pending",
        query: {
          page: pagePost,
          itemPerPage: this.itemPerPage,
          // batchOrder: this.searchInsuranceBatch ? this.searchInsuranceBatch.batchName : '',
          batchOrder : '',
          orderCode: this.searchOrderCode,
          lesseeName: this.searchLesseeName,
          productCode: this.searchProductCode,
          startRentFrom : this.searchStartRentFrom,
          startRentTo : this.searchStartRentTo,
          endRentFrom : this.searchEndRentFrom,
          endRentTo : this.searchEndRentTo,
          status: this.searchInsuranceStatus ?  this.searchInsuranceStatus.statusName : 'Pending',
        },
      });
      // location.reload();
      // this.getData();
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    openModal(modalName) {
      $("#modal" + modalName).modal("show");
    },
    getData() {
      this.loadingTable = true;
      this.searchLesseeName = this.$route.query.lesseeName;
      this.searchOrderCode = this.$route.query.orderCode;
      this.searchStartRentFrom = this.$route.query.startRentFrom;
      this.searchStartRentTo = this.$route.query.startRentTo;
      this.searchEndRentFrom = this.$route.query.endRentFrom;
      this.searchEndRentTo = this.$route.query.endRentTo;
      this.searchProductName = this.$route.query.productName;
      this.searchProductCode = this.$route.query.productCode;
      this.searchProductName = this.$route.query.productName;
      this.searchInsuranceStatus = this.$route.query.status ? this.insuranceStatusOptions.find(el => el.statusName == this.$route.query.status) : this.insuranceStatusOptions[1];
      this.searchInsuranceBatch = this.$route.query.batchOrder ? this.batchInsuranceOptions.find(el => el.batchName == this.$route.query.batchOrder) : '';
      this.currentPage = parseInt(this.$route.query.page);
      this.itemPerPage = parseInt(this.$route.query.itemPerPage);

      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      this.$http
      .post(
          process.env.GET_PENDING_INSURANCE_LIST, {
            page: this.currentPage,
            itemPerPage: this.itemPerPage,
            // batchOrder: this.searchInsuranceBatch ? this.searchInsuranceBatch.batchName : '',
            batchOrder : '',
            orderId: this.searchOrderCode,
            lesseName: this.searchLesseeName,
            productCode: this.searchProductCode,
            startRentFrom : this.searchStartRentFrom,
            startRentTo : this.searchStartRentTo,
            endRentFrom : this.searchEndRentFrom,
            endRentTo : this.searchEndRentTo,
            status: this.searchInsuranceStatus ? 
              ( this.searchInsuranceStatus.statusName.toLocaleLowerCase() == 'all'? '' : this.searchInsuranceStatus.statusName.toLocaleLowerCase())   
              : 'pending',
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
      .then((response) => {
        if(response.status == 200 || response.data.status == 200) {
          this.dataInsurance = response.data.data.data ? response.data.data.data : [];
          this.totalPage = response.data.data.totalPage;
          this.totalData = response.data.data.totalData;
          this.currentPage = response.data.data.currentPage;
        } else {
          swalWithBootstrapButtons.fire({
            icon: "error",
            title: "Failed",
            text: response.data.message,
          }).then((result) => {
            if(result.isConfirmed) {
            } 
          });
        }
         
          this.loadingTable = false;
        })
      .catch(error => {
        swalWithBootstrapButtons.fire({
          icon: "error",
          title: "Failed",
          text: error,
        }).then((result) => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        });
      });

      this.getActiveVendor()
    },
    dateFormat($date) {
      const d = new Date($date)
      if (d.getDate().toString().length == 1) {
        var date = '0' + d.getDate().toString()
      } else {
        date = d.getDate()
      }
      if ((d.getMonth() + 1).toString().length == 1) {
        var month = '0' + (d.getMonth() + 1).toString()
      } else(
        month = (d.getMonth() + 1)
      )
      return date + '-' + month + '-' + d.getFullYear()
    },

  },
  created() {
    const allPermission = JSON.parse(localStorage.getItem('roles'))
    this.cancelInsurancePermission = allPermission && allPermission.indexOf('15.2') >= 0
    this.getCartItemList()
    this.getData();
    this.selectedRows = localStorage.getItem("selectedPendingInsurance") ? JSON.parse(localStorage.getItem("selectedPendingInsurance")) : [];
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.cekPermission();
  },
  // computed: {
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
#filterPart {
  padding: 1rem;
}
.filter-field-name {
  font-family: Inter;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.1%;
  vertical-align: middle;
}
.table-field-name {
  font-family: Inter;
  font-weight: 700;
  font-style: Semi Bold;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.1%;
  vertical-align: middle;
}
tbody tr td {
  font-size: 0.9em;;
}
td {
  text-align: center;
}
th {
  text-align: center;
  vertical-align: middle;
}
.btn-view-cart .badge {
  margin-top : 2px;
  position: absolute;
  top: -10px;
  padding: 5px 7px;
  border-radius: 50%;
  background: rgba(247, 143, 48, 1);
  color: white;
  font-weight: 700;
}
.btn-view-cart:hover {
  background-color: rgba(214, 234, 253, 1);
}
.item-pending-badge {
  display: inline-block;
  padding: 0.25em 0.8em;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 1rem;
  transition: color 0.15s;
  margin-right: 2px;
  color: rgba(247, 143, 48, 1);
}
.item-no-issue-badge {
  display: inline-block;
  padding: 0.25em 0.8em;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 1rem;
  transition: color 0.15s;
  margin-right: 2px;
  color: rgba(76, 84, 100, 1);
}
.btn-add-cart{
  border-radius: 0.6rem;
}
.btn-add-cart:hover {
  background-color: rgba(214, 234, 253, 1);
}
.btn-remove-cart{
  border-radius: 0.6rem;
}
.btn-remove-cart:hover {
  background-color: #FEF4EA;
}
.total-data {
  margin-top: 7px;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.one-line {
  display: flex;
  margin: 5px 0px;
}

.border-red {
  border-color: red;
}

.one-line .ol-label.storage {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-roles {
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.stPrice-sch {
  width: 186px;
  margin: 7px 0px;
}

.delivery-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}

.input-group-addon {
  padding: 7px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  margin: 0px 0px 0px 0px;
  height: fit-content;
}

.label-addon-rp {
  margin: 5px 0px;
}

.modal-lg,
.modal-xl {
  max-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/PendingDeclarePage.vue